import React from 'react';
import { MaxElements, MaxElementsControls, Wrapper } from './pagination.styles';
import { Chip, Pagination as PaginationJuicy } from '@vtbhome/juicyfront';
import { PaginationProps } from './types';
import { Typography } from '../typography/typography';
import { DEFAULT_COUNTS_ON_PAGE } from './constants';
export const Pagination: React.FC<PaginationProps> = ({
    countOnPage,
    customCountsOnPage,
    onChangeCountOnPage,
    onChangePage,
    count,
    currentPage,
    disabled,
    ...paginationProps
}) => {
    const isShowCountsOnPage = typeof countOnPage === 'number' && !Number.isNaN(countOnPage) && onChangeCountOnPage;
    const countsOnPageList = customCountsOnPage || DEFAULT_COUNTS_ON_PAGE;
    const handleChangePage = (newPage: number) => {
        if (currentPage !== newPage) {
            onChangePage(newPage);
        }
    };

    return (
        <Wrapper>
            <PaginationJuicy
                disabled={disabled}
                count={Number.isNaN(count) ? 1 : count}
                currentPage={Number.isNaN(currentPage) ? 1 : currentPage}
                onChangePage={handleChangePage}
                {...paginationProps}
            />
            {isShowCountsOnPage && (
                <MaxElements>
                    <Typography size='body2_long' color={disabled ? 'neutral_30' : 'neutral_90'}>
                        Количество
                    </Typography>
                    <MaxElementsControls>
                        {countsOnPageList.map((el) => (
                            <Chip
                                disabled={disabled}
                                key={`${el.label}_${el.value}`}
                                type={countOnPage === el.value ? 'primary' : 'secondary'}
                                onClick={() => onChangeCountOnPage(el.value)}>
                                {el.label}
                            </Chip>
                        ))}
                    </MaxElementsControls>
                </MaxElements>
            )}
        </Wrapper>
    );
};
